import { getCurrentInstance, inject } from 'vue';
import { TopDialogHandle } from './dialogHandle';
import { AsyncTopDialogHandle } from './asyncDialogHandle';
import type { AsyncTopDialogComponentLoader, TopDialogComponent } from './types';
import { addDialogWorker, getDialogWorker } from '../dialogs/dialogs.vue';

/**
 * Получить объект управленя текущим диалоговым окном
 */
export const useTopDialogSelf = () => {
	// вызов из пользовтаельского компонента диалога
	const topDialogComponent = getCurrentInstance() as any;
	if (topDialogComponent?.type?.id) {
		const dialogWorker = getDialogWorker(topDialogComponent.type.id);
		if (dialogWorker) return dialogWorker;
	}

	return inject('dialogWorker') as TopDialogHandle<TopDialogComponent>;
};

/**
 * Получить объект управленя диалоговым окном
 *
 * При первом вызове компонент диалогового окна будет внедрен в компонент DialogWrapper
 */
export const useTopDialog = <T extends TopDialogComponent>(DialogComponent: T): TopDialogHandle<T> => {
	return addDialogWorker(DialogComponent);
};

/**
 * Получить объект управленя асинхронным диалоговым окном
 *
 * Компонент диалогового окна будет загружен и инициирован при первом взаимодействии с объектом
 *
 * Использует useTopDialog()
 */
export const useAsyncTopDialog = <T extends TopDialogComponent>(resolve: AsyncTopDialogComponentLoader<T>): AsyncTopDialogHandle<T> => {
	return new AsyncTopDialogHandle(resolve);
};
